import React, { useState, useEffect, useLayoutEffect } from "react";
import "./SBoardProvider.scss";

import { IonButton, IonIcon } from "@ionic/react";
import { addOutline, refreshCircleOutline } from "ionicons/icons";
import DoctorList from "../../../../../../../../components/Shared/DoctorList/doctor-list";
import { CONSTANTS } from "../../../../../../../../constants/callcentral.constants";
import {
  doctorListInputData,
  doctorListParams,
  doctorListResultInterface,
} from "../../../../../../../../components/Shared/DoctorList/doctor-list.model";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import { utilService } from "../../../../../../../../services";
import SBoardProviderModal from "./SBoardProviderModal/SBoardProviderModal";
import { doctorsListService } from "../../../../../../../../components/Shared/DoctorList/doctor-list-service";
import { sBoardProviderService } from "./SBoardProvider.service";
import classNames from "classnames/bind";
import GroupMediaShare from "../../../../../../../../components/Shared/GroupMediaShare/GroupMediaShare";
import _, { parseInt } from "lodash";
import { dataTransferService } from "../../../../../../../../services/dataTransferService";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export const AddProviderContext = React.createContext({
  updateProviderList: (params: any) => {},
  fromComponent: "",
  popUptype: "1",
  SelectedSupportStaffDetails: {
    common_provider: {},
    guid: "",
    id: null,
    name: "",
    site: null,
    specialisation: null,
  },
});

interface ContainerProps {
  showModal: boolean;
  refreshEnabled?: any;
  onCancel: (data: boolean) => void;
}

const SBoardProvider: React.FC<ContainerProps> = (props) => {
    const { t } = useTranslation("statusBoard");
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [isSelectAll, setSelectAll] = useState(false);
  const [showProviderCard, setShowProviderCard] = useState(false); //hide/show modal
  const [modeltype, setModeltype]: any = useState();
  const [updateDoctorlistResult, setupdateDoctorlistResult]: any = useState();
  const [apiParams, setApiParams] = useState<any>();
  const [doctorResult, setDoctorResult]: any = useState([]);
  const rowData = statusBoardService.rowData;

  const [providerListInput, setProviderListInput] =
    useState<doctorListInputData>({
      componentName: CONSTANTS.COMPONENTS.STATUS_BOARD,
      isMultiSelectEnabled: false,
      isShowColorBadge: false,
      isHideProfilePic: true,
      isShowCloseIcon: true,
    });
  const [showGroupMediaShareModal, setShowGroupMediaShareModal]: any =
    useState(false);

  let timeOutArray: any = [];
  

  // subscribe to get the doctor list after deletion.
  useEffect(() => {
    let subscription = sBoardProviderService.getDoctorListData.subscribe(
      (doctorlist: any) => {
        setDoctorResult(_.cloneDeep(doctorlist));
        setupdateDoctorlistResult(_.cloneDeep(doctorlist));
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  }, []);


const setRefreshBtnClick = () =>{
  let apiInputs = getDoctorListApiParams(true);
  getDoctorDetailsOnTime(apiInputs)
}

  useEffect(() => {   
    if (props.refreshEnabled) {
      // reloadDoctorListDetails();
    }
  }, [props.refreshEnabled]);

  const getDoctorListApiParams = (isUpdate: boolean) => {
    let apiInputs = {
      bedId:
        statusBoardService.rowData && statusBoardService.rowData.id
          ? statusBoardService.rowData.id
          : "",
      hour: utilService.getCurrentHour(),
      minute: isUpdate
        ? utilService.getCurrentMinutes() + 1
        : utilService.getCurrentMinutes(),
      date: utilService.getCurrentDate(),
      reg_code: utilService.getNetwork(),
    };
    return apiInputs;
  };

  const getStatusBoardDoctorListDetails = async (params: doctorListParams) => {
    setLoaderStatus(true);
    const respDoctorListResult: doctorListResultInterface =
      await doctorsListService.getStatusBoardDoctorList(params);
    if (respDoctorListResult.isSuccess) {
      setDoctorResult(_.cloneDeep(respDoctorListResult.doctorListResult));
      setupdateDoctorlistResult(
        _.cloneDeep(respDoctorListResult.doctorListResult)
      );
    } else {
      doctorsListService.handleErrorResponse();
    }
    setLoaderStatus(false);
  };

  const getDoctorDetailsOnTime = async (params: doctorListParams) => {
    setLoaderStatus(true);
    const respDoctorListResult: doctorListResultInterface =
      await doctorsListService.getStatusBoardDoctorList(params);
    if (respDoctorListResult.isSuccess) {
      setDoctorResult(_.cloneDeep(respDoctorListResult.doctorListResult));
      setupdateDoctorlistResult(
        _.cloneDeep(respDoctorListResult.doctorListResult)
      );
    } else {
      doctorsListService.handleErrorResponse();
    }
    setLoaderStatus(false);
  };

  useEffect(() => {
    timeOutArray.forEach((element: any) => {
      clearTimeout(element);
    });
    timeOutArray = [];

    let apiInputs = getDoctorListApiParams(false);
    setApiParams(apiInputs);
    getStatusBoardDoctorListDetails(apiInputs);
  }, []);


  useEffect(() => {
  const interval = setInterval(() => {
    const apiInputs = getDoctorListApiParams(true);
    setApiParams(apiInputs);
    getDoctorDetailsOnTime(apiInputs);
  }, 60000); // ⏱️ 1 minute

  return () => clearInterval(interval); // 🧹 cleanup
}, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getProviderListAction.subscribe(
      (data: any) => {
        if (!_.isEmpty(data)) {
          let apiInputs = getDoctorListApiParams(false);
          setApiParams(apiInputs);
          getStatusBoardDoctorListDetails(apiInputs);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const reloadDoctorListDetails = () => {
    if (!_.isEmpty(doctorResult)) {
      const getTime = new Date().toTimeString();
      const formatTime = getTime.slice(0, 8);
      const currentTime = formatTime.split(":");
      const getTimeInputData = currentTime[0] + ":" + currentTime[1];
      var shiftEndTimeArray: any = [];

      doctorResult.map((doctor: any) => {
        if (!_.isEmpty(doctor.shiftTime)) {
          doctor.shiftTime.map((shiftTime: any) => {
            shiftEndTimeArray.push(shiftTime.endTime);
          });
        }
      });

      const uniqueEndTimeArray = Array.from(new Set(shiftEndTimeArray));
      const currentTimeInSec = formatTimeInseconds(getTimeInputData);
      uniqueEndTimeArray.forEach((endTime: any) => {
        const reminder = formatAMPMtoSeconds(endTime);
        const timeDifference = reminder - currentTimeInSec;
        const formattedTimeDiffernce =
          timeDifference < 0 ? 86400 - timeDifference * -1 : timeDifference;

        let timeOut = setTimeout(() => {    
          if (formattedTimeDiffernce != 0) {
            let apiInputs = getDoctorListApiParams(true);
            setApiParams(apiInputs);
            getDoctorDetailsOnTime(apiInputs);
          }
        }, formattedTimeDiffernce * 1000);

        const timeOutObject = {
          timeOutID: timeOut,
        };
        const isTimeOutObjectAlreadyAdded = _.find(timeOutArray, {
          timeOutID: timeOut,
        });
        if (!isTimeOutObjectAlreadyAdded) {
          timeOutArray.push(timeOutObject);
        }
      });
    }
  };

  const formatTimeInseconds = (time: any) => {
    var array = time?.split(":");
    var timeInseconds =
      parseInt(array[0], 10) * 60 * 60 + parseInt(array[1], 10) * 60 + 0;

    return timeInseconds;
  };

  const formatAMPMtoSeconds = (timeValue: any) => {
    var splitByColon = timeValue.split(":");
    var hoursValue = parseInt(splitByColon[0]);
    var splitForMins = splitByColon[1].split(" ");
    if (splitForMins[1] === "PM") {
      hoursValue = hoursValue + 12;
    }
    var minutesValue = parseInt(splitForMins[0]);
    return 3600 * hoursValue + 60 * minutesValue;
  };

  const displayProviderCard = (type: String) => {
    setShowProviderCard(true);
    setModeltype(type);
  };

  const setUpdatedProviderList = (result: any) => {
    if (result && result.length) {
      setupdateDoctorlistResult(doctorsListService.setDoctorListModel(result));
      sBoardProviderService.setDoctorListDataFromComponent(
        doctorsListService.setDoctorListModel(result)
      );
      setDoctorResult(doctorsListService.setDoctorListModel(result));
    }
    if (
      modeltype === CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD &&
      result !== "" &&
      result.length === 0
    ) {
      props.onCancel(true);
    }
    setShowProviderCard(false);
  };

  return (
    <div className="sboard-provider-container">
      <div className="provider-header-wrapper">
        <div className="provider-heading">{t("providers")}</div>

        <div className="provider-button-container">
          <div className="file-share-button-div" title="Group Media Share">
            <div
              className="file-share-button input-icon icon-document"
              onClick={() => {
                setShowGroupMediaShareModal(true);
              }}
            ></div>

            <GroupMediaShare
              showModal={showGroupMediaShareModal}
              doctorListDataFromParent={doctorResult}
              onOk={() => {
                setShowGroupMediaShareModal(false);
              }}
              onCancel={() => {
                setShowGroupMediaShareModal(false);
              }}
              patientId={statusBoardService.rowData?.pid}
            ></GroupMediaShare>
          </div>

          <div className="primary-md-button">
            <IonButton
              className={classNames({
                btn: true,
                " rounded-btn": true,
                " add-primary-button": true,
                "disable-content ":
                  statusBoardService.rowData?.pid === " " ? true : false,
              })}
              type="button"
              onClick={() =>
                displayProviderCard(CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD)
              }
            >
              <IonIcon icon={addOutline}></IonIcon>
            <span>{t("primaryMd")}</span>
            </IonButton>
          </div>

          <div className="add-provider-button">
            <IonButton
              ion-button
              className={classNames({
                btn: true,
                " rounded-btn": true,
                "disable-content ":
                  statusBoardService.rowData?.pid === " " ? true : false,
              })}
              type="button"
              onClick={() =>
                displayProviderCard(CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER)
              }
            >
              <IonIcon icon={addOutline}></IonIcon>
          <span>{t("provider")}</span>
            </IonButton>
          </div>

          <li
            id="refreshBtn"
            onClick={
              setRefreshBtnClick}
            className={classNames({
              "sb-btn": true,
              "disable-content":
                rowData?.pid === " " ? true : false ? true : false,
            })}
          >
            <IonIcon
              icon={refreshCircleOutline}
              className="emergencyRedirect"
            ></IonIcon>
          </li>
        </div>
        <div>
          <AddProviderContext.Provider
            value={{
              updateProviderList: (result: any) =>
                setUpdatedProviderList(result),
              fromComponent: CONSTANTS.COMPONENTS.STATUS_BOARD,
              popUptype: modeltype,
              SelectedSupportStaffDetails: {
                common_provider: {},
                guid: "",
                id: null,
                name: "",
                site: null,
                specialisation: null,
              },
            }}
          >
            <SBoardProviderModal
              showModal={showProviderCard}
              onCancel={() => {
                setShowProviderCard(false);
              }}
            />
          </AddProviderContext.Provider>
        </div>
      </div>
      <div className="sb-card-container">
        <DoctorList
          apiParams={apiParams}
          doctorListDataFromParent={updateDoctorlistResult}
          disableCardSelection={true}
          doctorListInputData={providerListInput}
          permissions={rolePermissions}
          getSelectedCard={() => {}}
          getSelectedCardAndSchedule={() => {}}
          selectedAll={isSelectAll}
          getIsAllSelectedStatus={() => {}}
          getAllCards={() => {}}
          getAllCardsAndSchedule={() => {}}
          key={""}
          isFullScreen={false}
        ></DoctorList>
      </div>
    </div>
  );
};
export default SBoardProvider;
